import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const pesagemReducer = (state = InitialState.pesagemReducer, action) => {
    switch (action.type) {
        case ActionType.GET_PESAGENS_RESPONSE || ActionType.ADD_PESAGEM_RESPONSE || ActionType.EDIT_PESAGEM_RESPONSE: {
            return {
                ...state,
                pesagemObject: _.assign(action.pesagemObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default pesagemReducer;